import TextField from "@mui/material/TextField";

import WebService from "../util/webService";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { getRandomInt, printVariable, searchSchool } from "../util/helper";
import {
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  Menu,
  Typography,
} from "@mui/material";
import useDelegate from "@hooks/useDelegate";
import { Fragment, useEffect, useMemo, useRef, useState, forwardRef, useImperativeHandle  } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FlatButton from "@components/FlatButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "@mui/styles";
import Select from "@mui/material/Select";
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator";
import useAlert from '@hooks/useAlert'
import useSnackbar from '@hooks/useSnackbar';
import Dialog from '@mui/material/Dialog';
import ConfirmDialog from "@components/ConfirmDialog";
import { detectBrowser } from "@util/helper";
import { useParams, useLocation } from 'react-router-dom'
import { hashids } from '@util/helper';

const HashidPage = () => {
  const { alert, renderAlert } = useAlert()
  const [rawText, set_rawText] = useState('')


  return (
    <div>
      <h1>Hashid Page</h1>
      <TextField
        value ={rawText}
        onChange={e => {
          set_rawText(e.target.value)
        }}
      />
      <Button
        variant='contained'
        onClick={(e) => {
          const encoded = hashids.encode(rawText)
          console.log('encoded=>', encoded)
          alert(encoded)
        }}
      >
        해쉬ID</Button>
      {renderAlert()}
    </div>
  )
}

export default HashidPage